const jsonContentTypeHeaders = {
	'content-type': 'application/json',
};

export const vote = async ({
	voteUrl,
	id,
	answerIndex,
}: {
	voteUrl: string;
	id: string;
	answerIndex: number;
}) =>
	fetch(voteUrl, {
		body: JSON.stringify({
			pollId: id,
			answerIndex,
		}),
		headers: jsonContentTypeHeaders,
		method: 'POST',
	});
